import Layout from "@/layouts/layout";
import PageHeading from "@/components/layout/PageHeading";
import Panel from "@/components/ui/Panel";
import Badge from "@/components/ui/Badge";
import EmptyState from "@/components/ui/EmptyState";
import { ButtonLink } from "@/components/ui/Button";
import { Link } from "@inertiajs/react";
import { AUDIENCE_LABELS, type Guide } from "@/interfaces/guide";

export default function AdminGuides({ guides }: { guides: Guide[] }) {
  return (
    <Layout>
      <div className="flex flex-col gap-8">
        <PageHeading
          eyebrow="Admin"
          title="Guides"
          subtitle="Handbooks and FAQs, written in Markdown. Changes are live immediately - no deploy."
          actions={<ButtonLink href="/admin/guides/new">New guide</ButtonLink>}
        />

        {guides.length === 0 ? (
          <EmptyState
            title="No guides yet"
            description="Start with an organizer handbook - that's what new organizers ask for first."
            action={
              <ButtonLink href="/admin/guides/new">
                Write the first one
              </ButtonLink>
            }
          />
        ) : (
          <Panel title={`guides.csv - ${guides.length}`}>
            {guides.map((guide) => (
              <Link
                key={guide.id}
                href={`/admin/guides/${guide.id}/edit`}
                className="border-line/20 flex flex-wrap items-center gap-3 border-b py-2.5 last:border-b-0"
              >
                <span className="text-ink-soft font-display text-caption w-6 shrink-0">
                  {guide.position}
                </span>

                <div className="min-w-0 flex-1">
                  <p className="text-body text-ink truncate font-bold">
                    {guide.title}
                  </p>
                  <p className="text-caption text-ink-soft truncate">
                    /guides/{guide.slug}
                  </p>
                </div>

                <Badge tone="neutral">{AUDIENCE_LABELS[guide.audience]}</Badge>
                {guide.published ? (
                  <Badge tone="success">Published</Badge>
                ) : (
                  <Badge tone="warning">Draft</Badge>
                )}
              </Link>
            ))}
          </Panel>
        )}
      </div>
    </Layout>
  );
}
